import React from "react";

export default function NoPage() {
  return <div>Not Page found.</div>;
}
